import { render, staticRenderFns } from "./ed-select-template.component.vue?vue&type=template&id=bee4852e&scoped=true&"
import script from "./ed-select-template.component.ts?vue&type=script&lang=ts&"
export * from "./ed-select-template.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-select-template.component.scss?vue&type=style&index=0&id=bee4852e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee4852e",
  null
  
)

export default component.exports